import {
	GET_INSURANCE_COMPANY_BY_ID,
	GET_INSURANCE_COMPANY_BY_ID_SUCCESS,
	GET_INSURANCE_COMPANY_BY_ID_FAIL,
	GET_INSURANCE_COMPANY_BY_ID_RESET,
} from '../actions/getInsuranceCompanyByIdAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getInsuranceCompanyByIdReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_INSURANCE_COMPANY_BY_ID:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_INSURANCE_COMPANY_BY_ID_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_INSURANCE_COMPANY_BY_ID_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_INSURANCE_COMPANY_BY_ID_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getInsuranceCompanyByIdReducer;
